<script>
import api from "@/axios";
import Loader from "../components/loader";
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import MovDevTable from './movdevolucoes-table'
import appConfig from "@/app.config";
import Swal from "sweetalert2"
import { Vue3Lottie } from 'vue3-lottie'
import 'vue3-lottie/dist/style.css'
import animationJson from '@/assets/animations/transf_anim.json'
import exportFromJSON from "export-from-json"
import {getBaseUrl} from "@/helpers/baseUrl";


export default {
  page: {
    title: "Movimentos de Devolução",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, MovDevTable, Loader, Vue3Lottie,  },

  mounted() {
    console.log('mounted movdev-list_0')

    this.atualizaDataList()
  },

  data() {
    return {

      animationJson,
      title: 'Movimentos de Devolução',
      items: [
        {
          text: 'Estoque',
          href: '/',
        },
        {
          text: 'Movimentos de Devolução',
          active: true,
        },
      ],
      loadingList: true,
      loadingGraph: true,
      movDevList: null,
      movDevChart1: null,
      movDevChart2: null,
      pesqTextFilter: '',
      statusFilter: 'T',
    }
  },
  setup() {

  },


  methods: {
    exportExcel(){
      console.log('exportExcel')
      const data = this.movDevList
      const fileName = "exp_dados";
      const exportType = exportFromJSON.types.xls;
      if (data) exportFromJSON({ data, fileName, exportType });
    },


    atualizaDataList(){
      this.loadingList = true
      api.get(`${getBaseUrl()}api/movdevols`, {
        params: {
          'q': this.pesqTextFilter,
          's': this.statusFilter
        }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)


        this.movDevList = res.data[0]
        this.title = `(${this.movDevList.length}) Movimentos de Devolução`
        this.loadingList = false

        // console.log('movdevolsChart1')
        // console.log(movdevolsChart1)

        let labelsLocG1 = []
        let series01G1 = []
        let series02G1 = []
        res.data[1].forEach((value) => {
          // console.log(value)
          labelsLocG1.push(value.month)
          if (value.status === 'FA'){
            series01G1.push(value.valor)
          }else{
            series02G1.push(value.valor)
          }
        })
        const uniquelabelsLocG1 = [...new Set(labelsLocG1)]
        // console.log('series02G1')
        // console.log(series02G1)
        this.movDevChart1 = {
          series: [{
            name: 'Faturados',
            type: 'column',
            data: series01G1
          },
            {
              name: 'Outros',
              type: 'line',
              data: series02G1
            }],
          chartOptions: {
            chart: {
              stacked: false,
              toolbar: {
                show: false,
              }
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              width: 2,
              curve: 'smooth'
            },
            plotOptions: {
              bar: {
                columnWidth: '20%',
                endingShape: 'rounded'
              }
            },
            colors: ['#34c38f', '#556ee6'],
            fill: {
              gradient: {
                inverseColors: false,
                shade: 'light',
                type: "vertical",
                opacityFrom: 0.85,
                opacityTo: 0.55,
                //stops: [0, 100, 100, 100]
              }
            },
            labels: uniquelabelsLocG1,
            markers: {
              size: 0
            },
            yaxis: {
              min: 0
            },
          }
        }

        let labelsLocG2 = []
        let series01G2 = []
        let valorTotal = 0.00
        res.data[2].forEach((value) => {
          valorTotal += parseInt(value.valor)
        })
        console.log('valorTotal_G2')
        console.log(valorTotal)
        res.data[2].forEach((value) => {
          console.log(value)
          labelsLocG2.push(value.nome)

          const valorPerc = parseInt(value.valor / valorTotal * 100)
          console.log(valorPerc)

          series01G2.push(valorPerc)
        })
        this.movDevChart2 = {
          series: series01G2,
          chartOptions: {
            plotOptions: {
              radialBar: {
                dataLabels: {
                  name: {
                    fontSize: '22px',
                  },
                  value: {
                    fontSize: '16px',
                  },
                  total: {
                    show: true,
                    label: 'Total',
                    // eslint-disable-next-line no-unused-vars
                    formatter: function (w) {
                      // By default this function returns the average of all series. The below is just an example to show the use of custom formatter function
                      return valorTotal
                    }
                  }
                }
              }
            },
            labels: labelsLocG2,
            colors: ['#ff5900', '#ff9c00', '#3ec334', '#4cf1b7', '#f46a6a'],
          }
        }



        this.loadingGraph = false
      });
    },

    deletaReg(dataID) {
      console.log('deletaReg_pai dataID:')
      console.log(dataID)
      this.loadingList = true
      api.delete(`${getBaseUrl()}api/movdevol`, {
        params: {
          'iddata': dataID
        }
      }).then((res) => {
        console.log('then axios delete')
        console.log(res.data)
        this.atualizaDataList()
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações excluídas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
      })
    },


  },
}

</script>

<template>
  <Layout>

    <span class="float-end" style="z-index: 1000; position: absolute; top: 70px; right: 250px;">
      <Vue3Lottie :animationData="animationJson" :height="150" :width="150" />
    </span>

    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body" >
            <div class="row mb-2">

              <div class="col-sm-2">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input
                        id="inputPesquisa"
                        type="text"
                        v-model="pesqTextFilter"
                        class="form-control"
                        placeholder="Enter para pesquisar..."
                        @change="atualizaDataList"/>
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-sm-1">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <select
                        id="selectStatus"
                        v-model="statusFilter"
                        @change="atualizaDataList"
                        class="form-control select2-search-disable">
                      <option value="T" selected>Todos</option>
                      <option value="CO">Confirmado</option>
                      <option value="EL">Elaboração</option>
                      <option value="FA">Fatrurado</option>
                      <option value="CA">Cancelados</option>
                    </select>
                    <i class="bx bx-filter-alt search-icon"></i>
                  </div>
                </div>
              </div>


              <div class="col-sm-2">
                <div class="mb-2 d-inline-block">
                  <div class="position-relative">
                    <b-button variant="outline-primary" class="" @click="exportExcel">
                      <i class="bx bx-export font-size-16 align-middle "></i>
                    </b-button>
                  </div>
                </div>
              </div>

              <div class="col-sm-7">
                <div class="text-sm-end">
                  <router-link :to="`/movdevol/editar/0`">
                    <button type="button" class="btn btn-success btn-rounded mb-2 me-2" >
                      <i class="mdi mdi-plus me-1"></i> Nova Devolução
                    </button>
                  </router-link>

                </div>
              </div>
            </div>

            <Loader v-if="loadingList" style="min-height: 300px;">
            </Loader>

            <MovDevTable v-if="!loadingList"
                           :movDevList="movDevList"
                           @deletareg="deletaReg"/>

            <ul class="pagination pagination-rounded justify-content-end mb-2">
              <li class="page-item disabled">
                <a class="page-link" href="javascript: void(0);" aria-label="Previous">
                  <i class="mdi mdi-chevron-left"></i>
                </a>
              </li>
              <li class="page-item active">
                <a class="page-link" href="javascript: void(0);">1</a>
              </li>
              <li class="page-item disabled">
                <a class="page-link" href="javascript: void(0);" aria-label="Next">
                  <i class="mdi mdi-chevron-right"></i>
                </a>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </div>


    <Loader v-if="loadingGraph" style="min-height: 300px;">
    </Loader>


    <div class="row" v-if="!loadingGraph">

      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Evolução Mensal</h4>
            <apexchart
                class="apex-charts"
                type="line"
                height="370"
                :series="movDevChart1.series"
                :options="movDevChart1.chartOptions"
            ></apexchart>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Destaques Semana</h4>
            <apexchart
                class="apex-charts"
                height="370"
                type="radialBar"
                dir="ltr"
                :series="movDevChart2.series"
                :options="movDevChart2.chartOptions"
            ></apexchart>

          </div>
        </div>
      </div>

    </div>

  </Layout>
</template>

